const TextMsg = {
  //Common ------------------------------------------------------------->
  maxLengthError: 'max length is not greater than',
  token_error: 'Provided wrong or invalid token. Please login again',
  //Signin Page -------------------------------------------------------->
  email_signin_label: 'Email',
  password_signin_label: 'Password',
  email_signin_placeholder: 'Enter your Email',
  password_signin_placeholder: 'Enter your Password',
  email_error: 'Enter Email',
  email_valid_error: 'Enter Valid Email',
  password_error: 'Enter Password',
  register_nav_txt: 'Register',
  signin_btn_txt: 'Sign In',
  login_btn_txt: 'Login',

  //Register Page------------------------------------------------------->

  //Labels
  registerFirstNameLabel: 'First Name',
  registerLastNameLabel: 'Last Name',
  registeremailIdLabel: 'Email',
  registerphoneNumberLabel: 'Phone No',
  registercityNameLabel: 'City',
  registercountryNameLabel: 'Country',
  registercompanyNameLabel: 'Company Name',
  registerSubscriptionLabel: 'Subscription Type',
  registerCloudLabel:'Cloud',
  registerRegionLabel:'Region',
  registerdesignationLabel: 'Designation',
  registercountryCodeLabel: 'Country Code',
  registermessageLabel:'Message',
  registerlicenseKeyLabel:'License Key',

  //Placeholders
  registerFirstNameplaceholder: 'Enter your First Name',
  registerLastNameplaceholder: 'Enter your Last Name',
  registeremailIdplaceholder: 'Enter your Email',
  registerphoneNumberplaceholder: 'Enter your Phone Number',
  registercityNameplaceholder: 'Enter your City',
  registercountryNameplaceholder: 'Enter your Country',
  registercompanyNameplaceholder: 'Enter your Company Name',
  registerSubscriptionplaceholder: 'Enter Subscription ID',
  registerdesignationplaceholder: 'Enter your Designation',
  registercountryCodeplaceholder: 'Country Code',
  registermessageplaceholder:'Enter your Message',
  registerLicenseplaceholder: 'Enter Your License Key',

  //Errors
  registerFirstNameError: 'Enter First Name',
  registerLastNameError: 'Enter Last Name',
  registeremailError: 'Enter Email',
  registerphoneNumberError: 'Enter Phone Number',
  registercityNameError: 'Enter City',
  registercountryNameError: 'Enter Country',
  registercompanyNameError: 'Enter Company Name',
  registerdesignationError: 'Enter Designation',
  registercountryCodeError: 'Enter country code',
  registermessageError: 'Enter Message',

  //Valid Errors
  registeremailValidError: 'Enter Valid Email',
  registerphoneNumberValidError: 'Please enter a valid phone number',
  registerpasswordvalidError:
    'Password requires 1 uppercase, 1 lowercase, 1 number, 1 special character, and a length of 8-30 characters',
  registerRegisteredSuccess: 'Your Account Has Been Registered',
  registerRegisteredSubTextSuccess:
    'Kindly check your mail-id and verify your account to get activated ',
  registerAlreadyRegisteredError: 'Your Email have been already Registered',
  registerAlreadyRegisteredSubTextError:
    'Kindly Login with your registered Email or Register with another Mail-Id',
};
export default TextMsg;
